var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.5 23.8l-2.8-2.9 8.9-8.9-8.9-9L7.5.2 19.3 12z"}));
}

RightArrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
